export default __webpack_public_path__ + "static/media/skizze.18b19d66.png";